import { FolderItem, Location } from "@/types/fse";
import * as React from "react";
import { ROOT_DRIVE_NAME } from "@/views/drive/consts";
import { Link, useSearchParams } from "react-router";

import { isContractFamilyLink } from "@/views/drive/supplierContractFamilyNavigation";

interface Props {
  currentLocation: Location;
  currentFolder: FolderItem;
}

export const DriveHeaderBreadcrumbs: React.FC<Props> = ({ currentLocation, currentFolder }) => {
  const [searchParams] = useSearchParams();
  // A Contract Family's document list is not a My Folders location, so it has no My Folders path.
  if (isContractFamilyLink(searchParams)) return null;

  return (
    <nav className="flex flex-wrap text-sm text-gray-600">
      {currentLocation?.path.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.id}>
          <span className="mx-2">{">"}</span>
          <Link
            to={index === 0 && breadcrumb.name === ROOT_DRIVE_NAME ? "/drive" : `/drive/${breadcrumb.id}`}
            className="hover:underline"
          >
            {breadcrumb?.name}
          </Link>
        </React.Fragment>
      ))}
      <span className="mx-2">{">"}</span>
      <span>{currentFolder.name}</span>
    </nav>
  );
};
